import { render, staticRenderFns } from "./editRecipient.vue?vue&type=template&id=eb7faca6&scoped=true&"
import script from "./editRecipient.vue?vue&type=script&lang=js&"
export * from "./editRecipient.vue?vue&type=script&lang=js&"
import style0 from "./editRecipient.vue?vue&type=style&index=0&id=eb7faca6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb7faca6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
